import { filter, get } from 'lodash';
import useQueryParams from '../useQueryParams';

export function useFilterHandler() {
  const [query, setQuery] = useQueryParams();

  function handler(value: string) {
    return function onChange(event: React.ChangeEvent<HTMLInputElement>) {
      const { name, checked } = event.target;

      const existingValues = get(query, name, []);

      if (checked) {
        return setQuery({
          [name]:
            typeof existingValues === 'string'
              ? [existingValues, value]
              : [...existingValues, value]
        });
      }

      setQuery({
        [name]:
          typeof existingValues === 'string'
            ? undefined
            : filter(existingValues, v => v !== value)
      });
    };
  }

  return handler;
}
